import { TrackingEntry as GQLItem, TrackingProviderEnum } from '../../generated/graphql';
import { take } from '../../util';

export type TrackingEntry = {
  id: number;
  provider: TrackingProviderEnum;
  trackingId: string;
  conversionLabel?: string;
};

export const fromGql = (item: GQLItem): TrackingEntry =>
  take(item, 'id', 'provider', 'trackingId', 'conversionLabel');
